<template>
  <router-link :to="{name: 'chat-private', params: {id: user.id}}" class="list-group-item">
    <div class="card-body">
      <div class="card-body-side">
        <!-- user avatar -->
        <div>
          <img class="avatar" :src="user.avatar | emptyImage" alt="">
        </div>
      </div>
      <div class="card-body-content">
        <!-- replyCard header -->
        <div class="content-header">
          <span class="user-name">{{user.name}}</span>
          <span class="text-muted">{{user.account}}</span>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import { emptyImageFilter } from './../utils/mixins'

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  mixins: [emptyImageFilter]
}
</script>

<style scoped>

.card-body {
  position: relative;
  display: flex;
  padding: 15px 10px;
  align-items: center;
}

.card-body-side {
  width: 60px;
  height: 100%;
  text-align: center;
}

.card-body-content {
  width: 100%;
  height: 100%;
  padding-left: 10px;
}

.user-name {
  margin-right: 10px;
}

.content-body p {
  word-break: break-all;
}

</style>